<template>
<v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title class="grey lighten-4">
                    <v-tooltip top>
                         <v-btn
                            slot="activator"
                            dark
                            @click.stop="helpdialog = true"
                            icon class="mx-0">
                        <v-icon color="red">help</v-icon>
                        </v-btn>
                        <span>Entrega Papeles/App</span>
                    </v-tooltip>
                    <h3 class="headline mb-0">Hojas de seguridad</h3>

                    <v-spacer></v-spacer>
                        <v-text-field
                            @change="onChange"
                            slot="input"
                            v-model="search"
                            append-icon="search"
                            label="Buscar hoja de seguridad"
                            single-line
                            hide-details
                        ></v-text-field>

                </v-card-title>
                <div>

                  <v-data-table
                    :headers="headers"
                    :items="papeles"
                    :pagination.sync="pagination"
                    :total-items="total"
                    :rows-per-page-items="rowsPerPageItems"
                    :loading="loading"
                    row
                    wrap
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.lote }}</td>
                      <td>{{ props.item.start_in }}-{{ props.item.end_in }}</td>
                      <td>{{ props.item.papel }}</td>
                      <td>{{ props.item.status  ? props.item.cpc  : 'SIN ASIGNAR'}}</td>
                      <td>{{ props.item.digital ? 'SI' : 'NO' }}</td>
                      <td>{{ props.item.status ? props.item.usado ? 'SI' : 'NO' : 'SIN ASIGNAR'}}</td>
                      <td>{{ props.item.status ? props.item.anulado ? 'SI' : 'NO' : 'SIN ASIGNAR'}}</td>
                      <td class="text-xs-left">{{ props.item.status ? props.item.status : 'SIN ASIGNAR' }}</td>
                    </template>
                  </v-data-table>
                </div>

            </v-card>
        </v-flex>


  <!-- Inicio de dialogo -->
    <v-dialog
          v-model="helpdialog"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Hojas de seguridad</v-card-title>

            <v-card-text>
              Lista de hojas de seguridad del Colegio de Contadores Públicos Distrito Capital.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="helpdialog = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->


            <!-- loading -->
    <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
    >
        <v-card
            color="primary"
            dark
        >
            <v-card-text>
            Porfavor Espere...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
    </v-layout>
</template>

<script>
import Form from 'vform'
import axios from 'axios'

  export default {
    name: "admin-papeles-entrega-view",

    data: () => ({
        // entregados: false,
        papersP: [],
        dialog: false,
        helpdialog: false,
        loading: false,
        total: 0,

        search: '',
        pagination: {},
        headers: [
            { text: 'LOTE', align: 'left', sortable: false, value: 'lote' },
            { text: 'INICIA - FINALIZA', align: 'left', sortable: false, value: 'start_end' },
            { text: 'NRO PAPEL', align: 'left', sortable: false, value: 'papel' },
            { text: 'CPC', align: 'left', sortable: false, value: 'cpc' },
            { text: 'DIGITAL', align: 'left', sortable: false, value: 'digital' },
            { text: 'USADO', align: 'left', sortable: false, value: 'usado' },
            { text: 'ANULADO', align: 'left', sortable: false, value: 'anulado' },
            { text: 'ESTATUS', align: 'left', sortable: false, value: 'status' }
        ],
        rowsPerPageItems: [12, 24, 50, 150],
        papeles: [],
        editedIndex: -1,

        defaultItem: {
            name: '',
            description: ''
        },
    }),

    watch: {
      dialog (val) {
        val || this.close()
      },

      pagination() {
        this.getEntregaPaperByPagination();
      }
    },

    mounted() {
    },

    methods: {

        visulizarPapeles(props) {
            this.papersP = props.item
        },

        close () {
            this.dialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            }, 300)
        },

        async getEntregaPaperByPagination() {
                this.loading = true;
                if (this.search) {
                    await axios.get(`/api/securiy_papers/list-papel-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.papeles = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }

                if (this.pagination.sortBy && !this.search) {
                    const direction = this.pagination.descending ? 'desc' : 'asc';
                    await axios.get(`/api/securiy_papers/list-papel-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.papeles = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }

                if(!this.search && !this.pagination.sortBy) {
                    await axios.get(`/api/securiy_papers/list-papel?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            // console.log('Paginación inicial: ', res.data)
                            this.papeles = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
        },

        onChange () {
            this.getEntregaPaperByPagination();
        }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/atencion/listaPapeles.vue